import Vue from 'vue'
import Router from 'vue-router'

import Phase1 from './phase1'
import Management from './management'

Vue.use(Router)

var allRoutes = []
allRoutes = allRoutes.concat(Phase1)
allRoutes = allRoutes.concat(Management)

const routes = allRoutes

export const router = new Router({
    routes: routes,  //routes:routes
    mode: 'history', //  history/hash
    linkActiveClass: "active", // active class for non-exact links.
    linkExactActiveClass: "active" // active class for *exact* links.
})
